<template>
  <div class="d-flex">
    <b-button
      :disabled="!customerNotes"
      v-b-popover.hover.html="newlineToBreaks(customerNotes)"
      class="btn-sml mr-1"
      variant="info"
      title="Customer Log"
    >
      <i class="fa fa-user"></i>
    </b-button>
    <b-button
      :disabled="!internalNotes"
      v-b-popover.hover.html="newlineToBreaks(internalNotes)"
      class="btn-sml mr-1"
      variant="warning"
      title="Internal Log"
    >
      <i class="fa fa-envelope-o"></i>
    </b-button>
    <b-button
      :disabled="!connectLog"
      v-b-popover.hover.html="newlineToBreaks(connectLog)"
      class="btn-sml"
      variant="secondary"
      title="Connect Log"
    >
      <i class="fa fa-area-chart"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'OrderLogButtons',
  props: {
    customerNotes: {
      type: String,
      default: null
    },
    internalNotes: {
      type: String,
      default: null
    },
    connectLog: {
      type: String,
      default: null
    }
  },
  methods: {
    newlineToBreaks(txt) {
      if (!txt) return '';
      return txt.replace(/\n/g, '<hr style="margin:2px">');
    }
  }
};
</script>
